import { useEffect, useState } from 'react';

import { Grid, Typography } from '@mui/material';
import { getAllSendingDates } from 'src/shared/services/sendingService';

import ControlledSelectBox from 'src/shared/components/form/controlledSelectBox';
import { SelectBoxItem } from 'src/shared/models/gui/selectBoxItem';
import ControlledTextField from 'src/shared/components/form/controlledTextField';
import { useTranslation } from 'react-i18next';

const SendingTypeForm = () => {
  const { t } = useTranslation();
  const [sendingDates, setSendingDates] = useState<SelectBoxItem[]>([]);

  useEffect(() => {
    const fetchSendingDates = async () => {
      const result = await getAllSendingDates(0, 100, 'sndDate', '');

      const sendingDatesResult = result.data.results.map((item) => {
        return {
          label: new Date(item.sndDate).toISOString().substring(0, 10),
          value: item.sndDate_id.toString(),
        } as SelectBoxItem;
      });
      setSendingDates(sendingDatesResult);
    };
    fetchSendingDates();
  }, []);

  return (
    <>
      <Grid item xs={12}>
        <Typography variant='body1'>{t('common:sendingAttachmentForm')}</Typography>
      </Grid>
      <Grid item xs={12} md={6}>
        {sendingDates && <ControlledSelectBox name='date_id' label='Utskicksdatum' items={sendingDates} />}
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField
          name='selectionDescription'
          defaultValue=''
          multiline
          required
          rows={4}
          label='Urvalsbeskrivning'
          helperText='Exempelvis: Alla aktiva medlemmar i Hudiksvallsföreningen'
        />
      </Grid>
    </>
  );
};

export default SendingTypeForm;
